import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

import { Headers, Http, ResponseContentType } from '@angular/http';
import { LocalStorageService } from '../services/localStorage.service';

@Pipe({ name: 'image' })
export class ImagePipe implements PipeTransform {
  constructor(private http: Http,
    private lsService: LocalStorageService) {
  }

  transform(url: string) {
    const headers = new Headers({
      'Authorization': `Bearer ${this.lsService.getOauthToken().access_token}`,
      'Content-Type': 'image/*',
      'ce': `${this.lsService.getCe()}`
    });
    return this.http.get(url, { headers: headers, responseType: ResponseContentType.Blob })
      .map(response => response) // take the blob
      .switchMap(blob => {
        // return new observable which emits a base64 string when blob is converted to base64
        return Observable.create(observer => {
          const reader = new FileReader();
          reader.readAsDataURL(blob['_body']); // convert blob to base64
          reader.onloadend = function () {
            observer.next(reader.result); // emit the base64 string result
          };
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/images.pipe.ts